import { render } from "./EwgConfirm.vue?vue&type=template&id=7da98a7c&scoped=true"
import script from "./EwgConfirm.vue?vue&type=script&lang=js"
export * from "./EwgConfirm.vue?vue&type=script&lang=js"

import "./EwgConfirm.vue?vue&type=style&index=0&id=7da98a7c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7da98a7c"

export default script